import * as React from 'react';

import { i18nClient } from '@sailor/i18n-mach-pro';

import './index.css';

export interface BottomDialog {
  btnText?: string;
  onClose: () => void;
  didMountCb: () => void;
}

type BottomDialogCustomBodyProps = BottomDialog & {
  title: string;
  children: React.ReactNode;
}

const BottomDialogCustomBody: React.FC<BottomDialogCustomBodyProps> = ({
  title,
  children,
  btnText,
  onClose,
  didMountCb
}) => {
  React.useEffect(() => {
    didMountCb?.();
  }, [didMountCb]);

  const safeAreaHeight = Mach.env.safeAreaInsets.bottom || 20;
  return (
    <view className="dialog-content" onClick={() => {}}>
      <view className="platform-content">
        <view className="platform-content-top">
          <text content={title} className="platform-title" />

          {children}
        </view>
        <view className="platform-content-bottom">
          <text content={btnText || i18nClient.getText('order_detail_page_payamount_platformfee_popup_gotit')} className="primary-btn" onClick={onClose} />
        </view>
        <view className="safe-area-container" style={{ height: safeAreaHeight }} />
      </view>
    </view>
  );
};

export default BottomDialogCustomBody;
